export const LOGIN_WEB_VALIDATION_CODE_DATA = {
  web_enter_code_validation: {
    page_view: {
      hash: 'p-030.011.000.000.000.000',
      event: 'pages',
    },
    enter_validation_code: {
      hash: 'e-010.011.001.000.000.057',
      event: 'interactions',
    },
  },
  web_code_validation_success: {
    page_view: {
      hash: 'p-030.011.000.000.000.000',
      event: 'pages',
    },
  },
  active_page_validation: {
    page_view: {
      hash: 'p-030.014.000.000.000.000',
      event: 'pages',
    },
  },
  web_code_validation_error: {
    page_view: {
      hash: 'p-030.009.000.000.000.000',
      event: 'pages',
    },
    back: {
      hash: 'e-030.009.000.000.000.028',
      event: 'interactions',
    },
  },
};
